"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const separator_1 = require("@clds/separator");
const Separator = () => react_1.default.createElement(separator_1.HorizontalSeparator, null);
exports.Separator = Separator;
//# sourceMappingURL=Separator.js.map